//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import bus from "./LandMapNq/js/bus";
import { mapActions } from "vuex";

export default {
  components: {},
  props: [],
  data() {
    return {
      scrollShow: false,
      showCityFlag: false,
      communityList: [],
      loading: false,
      hasLocated: false,
      query: {
        masterName: "",
        cityCode: "",
        searchName:"",
        isMatchAddr: true,
        pageNo: 1,
        size: 20,
      },
      curCityName: "",
      selectParams: {
        collectType: "2",
        provinceId: "",
        cityId: "",
        areaId: "",
        bedroom: -1,
        livingRoom: -1,
        kitchen: -1,
        pageNo: 1,
        size: 20,
        bathroom: -1,
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    ...mapActions(["changeSearchName"]),
    remoteSearch(data) {
      console.log("remoteSearch---data:", data);
      this.query.masterName = data;
      this.query.pageNo = 1;
      this.communityList = [];
      this.querySearch();
    },
    //点击搜索item的逻辑
    handleSelect() {
      console.log(this.$refs.select.value);
      // bus.$emit("masterId", this.$refs.select.value);
      // bus.$emit("searchName", this.query.searchName);
      // sessionStorage.setItem('masterId',this.$refs.select.value)
      // sessionStorage.setItem('searchName',this.query.searchName)
      // this.resetSetItem('masterId', this.$refs.select.value);
      // this.resetSetItem('searchName', this.query.searchName);
      // console.log(this.$store.state.Agricultural.searchName);
      // this.changeSearchName(this.$refs.select.value)
        // console.log(this.$store.state.Agricultural.commit('changeSearchName',this.$refs.select.value));
        // this.changeSearchName(this.query.searchName)
        // console.log(this.$store.state.Agricultural.searchName);
        this.$emit('changeMasterId',this.$refs.select.value)
        this.$emit('changeSearchName',this.query.searchName)
    },
    //搜索关键词请求接口的逻辑
    querySearch() {
      this.$http.nqMonitor
        .listOfCooperatives(this.query)
        .then((res) => {
          console.log(res);
          this.communityList = res.data || [];
          this.communityList = this.setHightLight(
            this.communityList,
            this.query.masterName
          );
          console.log(this.query.masterName);
          // console.log(
          //   this.setHightLight(this.communityList, this.query.masterName)
          // );
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
    //设置高亮的逻辑
    setHightLight(arr, keyword) {
      console.log(arr, keyword);
      if (arr && arr.length > 0) {
        arr = arr.filter((item) => {
          let reg = new RegExp(
            this.formatForKeyword(this.query.masterName),
            "g"
          );
          let replaceString = `<span style="color:#f00;padding:0">${keyword}</span>`;
          console.log(replaceString);
          if (item.cooperativeName.match(reg)) {
            //为了不影响原始name，我们这里给item重新设置一个parseName，模板中显示的是parseName
            item.parseName = item.cooperativeName.replace(reg, replaceString);
            return item;
          }
        });
        return arr;
      }
    },
    // 解决 遇到特殊符号可能会转译 问题
    formatForKeyword(keyword) {
      var specChar = [
        "\\",
        "$",
        "(",
        ")",
        "*",
        "+",
        ".",
        "[",
        "]",
        "?",
        "^",
        "{",
        "}",
        "|",
        "'",
        '"',
      ];
      var starttime = new Date().getTime();
      let flag = false;
      for (var i = 0; i < specChar.length; i++) {
        if (keyword.indexOf(specChar[i]) >= 0) {
          flag = true;
          break;
        }
      }
      if (flag) {
        let keywordArr = keyword.split("");
        for (let i = 0; i < keywordArr.length; i++) {
          if (specChar.indexOf(keywordArr[i]) >= 0) {
            keywordArr[i] = "\\" + keywordArr[i];
          }
        }
        keyword = keywordArr.join("");
      }
      console.log("转义time: " + (new Date().getTime() - starttime));
      return keyword;
    },
    clearKeyword() {
      this.query.masterName = "";
      this.communityList = [];
      this.handleSelect();
      // bus.$emit("masterId", "");
      // sessionStorage.setItem('masterId','')
      this.resetSetItem('masterId', '');

    },
    searchON(e) {
      console.log(e);
      if (!this.query.masterName) {
        this.remoteSearch("");
      }
    },
    reset(){
      this.query.masterName = "";
      this.query.searchName = ""
      // this.resetSetItem('masterId','')
      // this.resetSetItem('searchName','')
      this.$emit('changeMasterId','')
        this.$emit('changeSearchName','')
      // bus.$emit("masterId", "");
      // bus.$emit("searchName", "");

    }
  },
};
